import React, { Component } from 'react'
import { reduxForm, Field, formValueSelector } from 'redux-form'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import axios from 'axios'
import { toastr } from 'react-redux-toastr'

import Row from '../../common/layout/row'
import LabelAndInput from '../../common/form/LabelAndInput'
import LabelAndSelect from '../../common/form/LabelAndSelect'
import { init } from './actions'
import BackButton from '../../common/form/BackButton'
import SubmitButton from '../../common/form/SubmitButton'

class Form extends Component {
    constructor(props) {
        super(props)
        this.state = { generalStatuses: [] }
    }

    componentWillMount() {
        this.getGeneralStatuses()
    }

    getGeneralStatuses = () => {
        axios.get(`${process.env.REACT_APP_API_HOST}/general_statuses`)
        .then(resp => {
            this.setState({ generalStatuses: resp.data.data })
        })
        .catch(e => {
            if (!e.response) {
                toastr.error('Erro', 'Desconhecido :-/')
                console.log(e)
            } else if (!e.response.data) {
                toastr.error('Erro', e.response.message)
            } else if (e.response.data) {
                toastr.error('Erro', e.response.data.message)
            }
        })
    }

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="card card-primary">
                    <div className="card-header">
                        <h3 className="card-title">Gerenciar Usuário</h3>
                    </div>
                    <div className='card-body'>
                        <Row>
                            <Field name='name' component={LabelAndInput} readOnly={this.props.readOnly}
                                label='Nome' cols='12 4' placeholder='Informe o nome' error={this.props.errors} />
                            <Field name='email' component={LabelAndInput} readOnly={this.props.readOnly}
                                type='email' label='E-mail' cols='12 4' placeholder='seu.email@mail.com' error={this.props.errors} />
                            <Field name='login' component={LabelAndInput} readOnly={this.props.readOnly}
                                label='Login' cols='12 4' placeholder='Informe o login' error={this.props.errors} />
                        </Row>
                        <Row>
                            <Field name='password' component={LabelAndInput} type="password" readOnly={this.props.readOnly}
                                label='Senha' cols='12 4' placeholder='Informe a senha' error={this.props.errors} />
                            <Field name='general_status_id' component={LabelAndSelect} readOnly={this.props.readOnly}
                                label='Status' cols='12 4' placeholder=' - Selecione - ' 
                                options={this.state.generalStatuses} error={this.props.errors} />
                        </Row>
                        <Row>
                            <Field name='blaze_email' component={LabelAndInput} readOnly={this.props.readOnly}
                                type='email' label='E-mail da Blaze' cols='12 4' placeholder='login usado na Blaze' error={this.props.errors}
                                title='Credencial da casa, usada pelo bot para logar na Blaze. Em branco, o bot usa o e-mail acima.' />
                            <Field name='blaze_pass' component={LabelAndInput} readOnly={this.props.readOnly}
                                label='Senha da Blaze' cols='12 4' placeholder='senha usada na Blaze' error={this.props.errors}
                                title='Necessária apenas para usuários do perfil Bot.' />
                        </Row>
                        <Row>
                            <Field name='percent_to_start' component={LabelAndInput} readOnly={this.props.readOnly}
                                type='number' step='any' label='% de entrada' cols='12 3' placeholder='2' error={this.props.errors}
                                title='Porcentagem do saldo na primeira aposta. Mínimo da casa (R$ 2) aplica em cima. Padrão: 2%.' />
                            <Field name='max_bet_value' component={LabelAndInput} readOnly={this.props.readOnly}
                                type='number' step='any' label='Teto da aposta (R$)' cols='12 3' placeholder='100' error={this.props.errors}
                                title='Valor máximo por aposta em reais. Padrão: 100.' />
                            <Field name='gale_max_steps' component={LabelAndInput} readOnly={this.props.readOnly}
                                type='number' step='1' label='Jogadas por sinal' cols='12 3' placeholder='4' error={this.props.errors}
                                title='Total de jogadas por sinal (entrada inclusa). Gale 4 = 4 jogadas; gale 3 = 3. Padrão: 4.' />
                            <Field name='signals_to_wait_on_loss' component={LabelAndInput} readOnly={this.props.readOnly}
                                type='number' step='1' label='Espera pós-perda' cols='12 3' placeholder='3' error={this.props.errors}
                                title='Após uma perda, o bot NÃO aposta até haver N sucessos consecutivos só nos prompts deste bot. 0 = joga todo sinal desses prompts. Padrão: 3.' />
                        </Row>
                    </div>
                    <div className='card-footer'>
                        <SubmitButton label='Salvar' />
                        <BackButton label='Cancelar' />
                    </div>
                </div>
            </form>
        )
    }
}

Form = reduxForm({ form: 'userForm', destroyOnUnmount: false })(Form)
const selector = formValueSelector('userForm')
const mapStateToProps = state => ({
    name: selector(state, 'name'),
    email: selector(state, 'email'),
    login: selector(state, 'login'),
    password: selector(state, 'password'),
    general_status_id: selector(state, 'general_status_id'),
    blaze_email: selector(state, 'blaze_email'),
    blaze_pass: selector(state, 'blaze_pass'),
    percent_to_start: selector(state, 'percent_to_start'),
    max_bet_value: selector(state, 'max_bet_value'),
    gale_max_steps: selector(state, 'gale_max_steps'),
    signals_to_wait_on_loss: selector(state, 'signals_to_wait_on_loss'),
    errors: state.user.errors
})
const mapDispatchToProps = dispatch => bindActionCreators({ init }, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(Form)